export default __webpack_public_path__ + "static/media/chef-choice.cca7d9a3.svg";